import { render, staticRenderFns } from "./IncomingNotificationPanel.vue?vue&type=template&id=55246097&scoped=true"
import script from "./IncomingNotificationPanel.vue?vue&type=script&lang=js"
export * from "./IncomingNotificationPanel.vue?vue&type=script&lang=js"
import style0 from "./IncomingNotificationPanel.vue?vue&type=style&index=0&id=55246097&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55246097",
  null
  
)

export default component.exports